
import React from 'react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import { MessageSquare, Plus, Settings } from 'lucide-react';

type DashboardHeaderProps = {
  isCandidat: boolean;
  isEntreprise: boolean;
  isAdmin: boolean;
};

const DashboardHeader = ({ isCandidat, isEntreprise, isAdmin }: DashboardHeaderProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 md:mb-8 gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800">
          {isAdmin ? "Administration" : "Tableau de bord"}
        </h1>
        <p className="text-sm md:text-base text-gray-600">
          {isAdmin 
            ? "Gérez tous les espaces de la plateforme"
            : isCandidat 
              ? "Suivez vos feedbacks et progressez dans votre carrière"
              : "Gérez vos évaluations et recrutements"}
        </p>
      </div>
      
      <div className="flex flex-wrap gap-2 md:gap-3 self-end md:self-center">
        {(isEntreprise || isAdmin) && (
          <>
            <Button 
              variant="outline" 
              onClick={() => navigate('/request-feedback')}
              className="flex items-center gap-2 bg-white"
              size={isMobile ? "sm" : "default"}
            >
              <MessageSquare className="h-4 w-4" />
              <span>Demander</span>
            </Button>
            <Button 
              onClick={() => navigate('/create-feedback')}
              className="flex items-center gap-2 bg-brandBlue"
              size={isMobile ? "sm" : "default"}
            >
              <Plus className="h-4 w-4" />
              <span>Créer un feedback</span>
            </Button>
          </>
        )}
        {isCandidat && (
          <Button 
            onClick={() => navigate('/request-feedback')}
            className="flex items-center gap-2 bg-brandBlue"
            size={isMobile ? "sm" : "default"}
          >
            <MessageSquare className="h-4 w-4" />
            <span>Demander un feedback</span>
          </Button>
        )}
        {isAdmin && (
          <Button 
            variant="outline" 
            onClick={() => navigate('/admin')}
            className="flex items-center gap-2 bg-white"
            size={isMobile ? "sm" : "default"}
          >
            <Settings className="h-4 w-4" />
            <span>Administration</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default DashboardHeader;
